import './App.css';
import {
	Main,
	Authorization,
	Registration,
	RegistrationFinal,
	UserProfile,
	CurrentBiddings,
	CompletedBiddings,
	Rules
} from './pages';
import {
	Layout,
	AcceptNotifications,
	Popup
} from './components';
import {
	createBrowserRouter,
	RouterProvider,
	redirect
} from "react-router-dom";
import { $showNotification, $notificationMessage, $severity, setShowNotification } from './store/notification';
import { useUnit } from 'effector-react';
import Cookies from 'universal-cookie';
import { setIsAuth } from './store/isAuthStore'
import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from 'react';
import { getCurrentUser } from './components/api';
import { $userData, setUserData } from './store/userData';
import {
	checkNotificationSupport
} from './services/notificationService';
import { Snackbar, Alert } from '@mui/material';
import { setPushNotification } from './store/pushNotifications';
import * as signalR from '@microsoft/signalr';

const isTokenExpired = (token) => {
	if (!token) {
		return true; // Если токена нет, он "просрочен"
	}
	try {
		const decodedToken = jwtDecode(token);
		const currentTime = Date.now() / 1000;
		return decodedToken.exp < currentTime;
	} catch (error) {
		console.error("Error decoding token:", error);
		return true;
	}
};

const cookies = new Cookies();
const token = cookies.get('token');
const acceptNotificationsShowed = cookies.get('acceptNotificationsShowed');
let isAuth = !isTokenExpired(token);
setIsAuth(isAuth);

const webSocketUrl = process.env.REACT_APP_SOCKET_URL;

const router = createBrowserRouter([
	{
		loader: async () => {
			if (!isAuth)
				throw redirect("/authorization");
			return null;
		},
		children: [
			{ path: "/", element: <Main /> },
			{ path: "/userProfile", element: <UserProfile /> },
			{ path: "/rules", element: <Rules /> }
		]
	},
	{
		path: "authorization",
		element: <Authorization />
	},
	{
		path: "/registration",
		element: <Registration />,
	},
	{
		path: "/registrationFinal",
		element: <RegistrationFinal />
	},
	{
		path: "/userProfile",
		element: <UserProfile />
	},
	{
		path: "/rules",
		element: <Rules />
	},
	{
		path: "/currentBiddings",
		element: <CurrentBiddings />
	},
	{
		path: "/completedBiddings",
		element: <CompletedBiddings />
	}
]);

function App() {

	const [isSupported, setIsSupported] = useState(false);
	const [isSubscribed, setIsSubscribed] = useState(false);
	const [showPopup, setShowPopup] = useState(false);
	const [notificationSocketConnection, setNotificationSocketConnection] = useState(null);

	const showNotification = useUnit($showNotification);
	const notificationMessage = useUnit($notificationMessage);
	const severity = useUnit($severity);
	const userData = useUnit($userData);

	useEffect(() => {
		setIsSupported(checkNotificationSupport());
		checkSubscription();
	}, []);

	const checkSubscription = async () => {
		if ('serviceWorker' in navigator) {
			const reg = await navigator.serviceWorker.ready;
			const subscription = await reg.pushManager.getSubscription();
			setIsSubscribed(!!subscription);
		}
	};

	useEffect(() => {
		if (!isSubscribed && isAuth) {
			const timer = setTimeout(() => {
				setShowPopup(!isSubscribed && isAuth && !acceptNotificationsShowed);
			}, 1000);

			return () => clearTimeout(timer);
		}
	}, [isSubscribed, isAuth])


	useEffect(() => {
		if (isAuth) {
			getCurrentUser().then(data => {
				setUserData(data);
			})
				.catch(error => {
					setIsAuth(false);
					if (error.response.status !== 401)
						console.log(error)
				})
		}
	}, [isAuth]);

	useEffect(() => {
		if (!notificationSocketConnection) {
			const newConnection = new signalR.HubConnectionBuilder()
				.withUrl(`${webSocketUrl}/sockets/notifications`, {
					skipNegotiation: true,
					transport: signalR.HttpTransportType.WebSockets
				})
				.build();

			setNotificationSocketConnection(newConnection);
		}
	}, []);

	useEffect(() => {
		if (notificationSocketConnection && userData.id) {
			notificationSocketConnection.start().then(() => {
				notificationSocketConnection.invoke("SendNotifications", userData.id);
				notificationSocketConnection.on("NotificationsListUpdate", (data) => {
					setPushNotification(JSON.parse(data));
				});
			}).catch((exception) => console.log(exception));
		}
	}, [notificationSocketConnection, userData]);

	const handleCloseAcceptNotifications = () => {
		cookies.set('acceptNotificationsShowed', true, { path: '/' });
		setShowPopup(false);
	};

	return (
		<div className="App">
			<Layout>
				<RouterProvider router={router} />
			</Layout>
			<Popup show={showPopup} onClose={() => handleCloseAcceptNotifications()}>
				<AcceptNotifications setShowPopup={() => handleCloseAcceptNotifications()} setIsSubscribed={(value) => setIsSubscribed(value)} isSupported={isSupported} />
			</Popup>
			<Snackbar open={showNotification} autoHideDuration={5000} onClose={() => setShowNotification(false)} style={{ position: 'fixed', bottom: '100px', zIndex: "10000 !important" }}>
				<Alert onClick={() => setShowNotification(false)} severity={severity}>
					{notificationMessage}
				</Alert>
			</Snackbar>

		</div>
	);
}

export default App;
